import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Button } from '@components';
import ReactSpinner from '../../components/reactSpinner/ReactSpinner';

import {
    quyTrinhGetAllAction,
    quyTrinhUpdateAction
} from '@app/store/reducers/quyTrinh';
import { URI_INTERNAL } from '@app/utils/pathLocations';
import { toast } from 'react-toastify';
import { messageToast } from '@app/utils/define';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const QuyTrinhEdit = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const query = useQuery();
    const idParam = query.get('id');
    const id = idParam ? parseInt(idParam, 10) : NaN;

    const { list } = useSelector((state) => state.quyTrinh);
    const [name, setName] = useState('');
    const [thuTu, setThuTu] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!list || list.length === 0) {
            dispatch(quyTrinhGetAllAction());
        }
    }, [dispatch, list]);

    useEffect(() => {
        if (!Array.isArray(list) || Number.isNaN(id)) return;

        const current = list.find((x) => x.id === id);
        if (current) {
            setName(current.name || '');
            setThuTu(
                typeof current.thuTu === 'number'
                    ? String(current.thuTu)
                    : current.thuTu || ''
            );
        }
    }, [list, id]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Number.isNaN(id)) {
            toast.error('Thiếu id Quy trình');
            return;
        }

        const model = {
            name,
            thuTu: thuTu ? parseInt(thuTu, 10) : 0
        };

        try {
            setIsSubmitting(true);
            await dispatch(
                quyTrinhUpdateAction({ id, data: model })
            ).unwrap();

            toast.success(messageToast.messageToastUpdateSuccess);
            history.push(URI_INTERNAL.QUYTRINH_PATH);
        } catch (err) {
            console.error('Cập nhật Quy trình lỗi:', err);

            let msg =
                (err && err.message) ||
                (typeof err === 'string' ? err : '') ||
                (err && err.title) ||
                '';

            if (!msg && err && err.errors) {
                msg = Object.values(err.errors).flat().join('; ');
            }

            toast.error(
                msg
                    ? `${messageToast.messageToastUpdateError}: ${msg}`
                    : messageToast.messageToastUpdateError
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        history.push(URI_INTERNAL.QUYTRINH_PATH);
    };

    if (Number.isNaN(id)) {
        return (
            <Card>
                <Card.Header as="h5">Sửa Quy trình</Card.Header>
                <Card.Body>Thiếu id</Card.Body>
            </Card>
        );
    }

    return (
        <Card>
            <Card.Header as="h5">Sửa Quy trình</Card.Header>
            <Card.Body>
                <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Tên Quy trình
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Tên Quy trình"
                                type="text"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Form.Label className="col-sm-2 col-form-label">
                            Thứ tự
                        </Form.Label>
                        <Col sm="10">
                            <Form.Control
                                placeholder="Thứ tự"
                                type="number"
                                value={thuTu}
                                onChange={(e) => setThuTu(e.target.value)}
                                required
                            />
                        </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-3">
                        <Col md={{ span: 10, offset: 2 }}>
                            <ButtonGroup>
                                <Button
                                    type="submit"
                                    theme="primary"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? 'Đang lưu...' : 'Lưu'}
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    type="button"
                                    theme="secondary"
                                    onClick={handleCancel}
                                    disabled={isSubmitting}
                                >
                                    Hủy
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Form.Group>
                </Form>

                <ReactSpinner loadings={isSubmitting} />
            </Card.Body>
        </Card>
    );
};

export default QuyTrinhEdit;
